import { Progress } from "@/components/atoms/Progress";

interface PercentageProgressProps {
  rate: number | null;
}

const PercentageProgress = ({ rate }: PercentageProgressProps) => {
  if (rate === null) return false;

  const percentage = rate * 100;

  return (
    <div className="flex flex-row items-center gap-3 min-w-36">
      <Progress
        value={percentage}
        className="h-2 bg-gray-200"
        indicatorClassName="bg-purple-600"
      />
      {Math.round(percentage)}%
    </div>
  );
};

export default PercentageProgress;
